module.exports = __webpack_public_path__ + "static/media/eeuu.6872ec3f.png";